import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setTheme } from '../store/slices'
import { setThemeColorsFromURL } from '../theme/config'
import { getUrlParams } from '../utils/helpers/common'

const useSetTheme = (type = null) => {
  const params = getUrlParams()
  const dispatch = useDispatch()

  useEffect(() => {
    applyTheme(type)
  }, [params, type])

  const applyTheme = (type) => {
    const themeRes = setThemeColorsFromURL(type)
    dispatch(
      setTheme({
        currentTheme: type,
        activeTheme: themeRes,
      }),
    )
  }
  return { applyTheme }
}

export default useSetTheme
